import { Toast } from "vant";
const toastDuration = 1500;

export function ToastFail(message) {
    Toast({ message: message, duration: toastDuration });
}

export function ToastSuccess(message) {
    Toast.success({ message: message, duration: toastDuration });
}

export function Loading() {
    return Toast.loading({
        forbidClick:true,
        message: "加载中..."
    })
}